








































































































































































































import useMessagingFilters from "@/composables/useMessagingFilters";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useTagsStore } from "@/store/useTagsStore";
import { useTeamsStore } from "@/store/useTeamsStore";
import { defineComponent, ref, watch } from "@vue/composition-api";
import { useContactsStore } from "@/store/useContactsStore";
import { useUsersStore } from "@/store/useUsersStore";
import { StoredFilterKey } from "@/types/filter.types";

import {
    BBadge,
    BDropdown,
    BDropdownForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BTab,
    BTabs,
    VBTooltip,
} from "bootstrap-vue";
import { cloneDeep } from "lodash";
import { storeToRefs } from "pinia";

export default defineComponent({
    components: {
        BFormInput,
        BBadge,
        BDropdown,
        BDropdownForm,
        BFormCheckbox,
        BFormCheckboxGroup,
        BFormGroup,
        BListGroup,
        BListGroupItem,
        BTab,
        BTabs,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { filters, setFilterToLocalStorage } = useMessagingFilters();

        const { channels } = storeToRefs(useChannelsStore());
        const { labels } = storeToRefs(useContactsStore());
        const { users } = storeToRefs(useUsersStore());
        const { tags } = storeToRefs(useTagsStore());
        const { teams } = storeToRefs(useTeamsStore());

        const localChannels = ref(cloneDeep(channels.value));
        const localLabels = ref(cloneDeep(labels.value));
        const localAgents = ref(cloneDeep(users.value));
        const localTags = ref(cloneDeep(tags.value));
        const localTeams = ref(cloneDeep(teams.value));

        const validateSelectedFilter = (filterName: StoredFilterKey, availableValues: number[]) => {
            filters[filterName] = filters[filterName].filter((filterId) => availableValues.includes(filterId));

            setFilterToLocalStorage(filterName, filters[filterName]);
        };

        const filterLabelsByKeyword = (val: string) => {
            localLabels.value = labels.value?.filter((label) => label.name.toLowerCase().includes(val.toLowerCase()));
        };

        const filterAgentsByKeyword = (val: string) => {
            localAgents.value = users.value?.filter((user) => user.name.toLowerCase().includes(val.toLowerCase()));
        };

        const filterTagsByKeyword = (val: string) => {
            localTags.value = tags.value?.filter((tag) => tag.name.toLowerCase().includes(val.toLowerCase()));
        };

        const filterTeamsByKeyword = (val: string) => {
            localTeams.value = teams.value?.filter((team) => team.name.toLowerCase().includes(val.toLowerCase()));
        };

        const filterChannelsByKeyword = (val: string) => {
            localChannels.value = channels.value?.filter((channel) =>
                channel.name.toLowerCase().includes(val.toLowerCase())
            );
        };

        const labelsKeyword = ref("");
        watch(labelsKeyword, (nVal) => {
            if (nVal !== "") {
                filterLabelsByKeyword(nVal);
            } else {
                localLabels.value = labels.value;
            }
        });

        const agentsKeyword = ref("");
        watch(agentsKeyword, (nVal) => {
            if (nVal !== "") {
                filterAgentsByKeyword(nVal);
            } else {
                localAgents.value = users.value;
            }
        });

        const tagsKeyword = ref("");
        watch(tagsKeyword, (nVal) => {
            if (nVal !== "") {
                filterTagsByKeyword(nVal);
            } else {
                localTags.value = tags.value;
            }
        });

        const teamsKeyword = ref("");
        watch(teamsKeyword, (nVal) => {
            if (nVal !== "") {
                filterTeamsByKeyword(nVal);
            } else {
                localTeams.value = cloneDeep(useTeamsStore().getRestrictedTeams());
            }
        });

        const channelsKeyword = ref("");
        watch(channelsKeyword, (nVal) => {
            if (nVal !== "") {
                filterChannelsByKeyword(nVal);
            } else {
                localChannels.value = channels.value;
            }
        });

        // watch data for all resource stories
        watch(channels, (nValue) => {
            localChannels.value = cloneDeep(nValue);

            validateSelectedFilter(
                "channels",
                localChannels.value.map((v) => v.id)
            );
        });

        watch(labels, (nValue) => {
            localLabels.value = cloneDeep(nValue);

            if (labelsKeyword.value !== "") {
                filterLabelsByKeyword(labelsKeyword.value);
            }

            validateSelectedFilter(
                "labelIds",
                localLabels.value.map((v) => v.id)
            );
        });

        watch(teams, (nValue) => {
            localTeams.value = cloneDeep(useTeamsStore().getRestrictedTeams());

            validateSelectedFilter(
                "teams",
                localTeams.value.map((v) => v.id)
            );
        });

        watch(users, (nValue) => {
            localAgents.value = cloneDeep(nValue);

            if (agentsKeyword.value !== "") {
                filterAgentsByKeyword(agentsKeyword.value);
            }

            validateSelectedFilter(
                "userIds",
                localAgents.value.map((v) => v.id)
            );
        });

        watch(tags, (nValue) => {
            localTags.value = cloneDeep(nValue);

            validateSelectedFilter(
                "tags",
                localTags.value.map((v) => v.id)
            );
        });

        return {
            filters,
            // tabs data
            localChannels,
            localTags,
            localTeams,
            localLabels,
            localAgents,
            // keyword refs
            labelsKeyword,
            agentsKeyword,
            tagsKeyword,
            teamsKeyword,
            channelsKeyword,
            // helpers
            setFilterToLocalStorage,
        };
    },
});
